<div>
  <div style="padding: 10px">
    @for (actionDef of activeState.actionDefs(); track actionDef.getTitle()) {
      <div
        class="nav-item {{ isActive(actionDef) ? 'nav-item-active' : '' }}"
        (click)="frame().executeAction(actionDef)"
      >
        <div class="flex">
          <div>
            <mng-icon color="white" style="margin-right: 10px" [iconName]="actionDef.getIconName()" [fontSize]="20" />
          </div>

          <div>{{ actionDef.getTitle() }}</div>
        </div>
      </div>
    }
  </div>
</div>
